const placements = {
    registration: ['signup_footnote'],
    account_settings: ['account_email_preferences'],
    public_newsletter: ['mailing_list_page', 'tool_feature'],
};
const createAcquisitionTracker = (track, source, placement) => {
    let inFlight = false;
    const emit = (event, extra = {}) => {
        if (!placements[source]?.includes(placement)) return;
        try {
            track(event, { source, placement, ...extra });
        } catch {
            // Analytics must never interrupt enrollment.
        }
    };
    return {
        begin: () => {
            if (inFlight) return false;
            inFlight = true;
            emit('newsletter_signup_attempt');
            return true;
        },
        settle: (accepted, status = 'unknown', authoritative = false, category = 'unknown') => {
            if (!inFlight) return;
            inFlight = false;
            if (accepted) {
                const membershipStatus =
                    authoritative && ['subscribed', 'pending'].includes(status)
                        ? status
                        : 'unknown';
                emit('newsletter_signup_accepted', { membership_status: membershipStatus });
            } else {
                emit('newsletter_signup_failed', {
                    failure_category: ['network', 'provider', 'validation'].includes(category)
                        ? category
                        : 'unknown',
                });
            }
        },
    };
};

module.exports = { createAcquisitionTracker };
